// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.business-container-Jkmj2 {
  overflow-x: auto;
  padding: 0px 32px 20px;
}

.business-toolbar-lEADJ {
  min-width: 1060px;
  height: 56px;
  display: flex;
  gap: 32px;
  align-items: center;
}

.business-toolbarRight-Eo0aA {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-grow: 1;
  gap: 24px;
  overflow: auto;
}

.business-title_container-YINeu {
  width: 360px;
  flex-grow: 0;
  flex-shrink: 0;
}

.business-title_title-ahSgm {
  font-size: 17px;
}

.business-title_icon-wAVXj {
  --size: 20px;
}

.business-tab_container-xcWPa, .business-tab_container-xcWPa:first-of-type {
  cursor: pointer;
  padding: 0px;
}

.business-tab_container-xcWPa:first-of-type {
  margin-left: 4px;
}

.business-tab_container-xcWPa:not(:last-of-type) {
  margin-right: 48px;
}

.business-tab_container-xcWPa:hover {
  background-color: unset;
}

.business-tab_title-okVb5 {
  font-size: 15px;
  color: rgba(0, 0, 0, 0.9);
}

.business-tab_indicator-gyHBB {
  border-radius: 2px;
  margin: 8px 2px 0px;
}

.business-tableHeader_container-oktDX {
  height: 48px;
}

.business-tableHeader_cellContent-pzr6m {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.8);
}

.business-content-ih5Le {
  min-width: 1060px;
  display: flex;
  gap: 32px;
  margin-top: 0px;
}

.business-outlineCard-poAbG {
  height: auto;
  flex-grow: 1;
  overflow: auto;
}

.business-customerCard_container-Ap1yT {
  width: 360px;
  flex-shrink: 0;
}

.business-salesReport_item-nCTM_:first-child {
  margin-left: 0px;
}

.business-options-No5IO {
  display: flex;
  align-items: center;
}

.business-option-Qn7e5 {
  --size: 24px;
  margin-left: 28px;
}

.business-confirmModal_content-_haz5 {
  font-size: 15px;
  line-height: 1.6;
}

.business-confirmModal_content-_haz5 b {
  font-weight: 500;
}

.business-error-OQghz {
  margin-top: 12px;
  padding: 8px 12px;
  border-radius: var(--radius-lg);
  background-color: var(--color-red-50);
  color: var(--accent-color);
}
`, "",{"version":3,"sources":["webpack://./src/pages/business/business.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,YAAY;EACZ,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,+BAA+B;EAC/B,qCAAqC;EACrC,0BAA0B;AAC5B","sourcesContent":[".container {\n  overflow-x: auto;\n  padding: 0px 32px 20px;\n}\n\n.toolbar {\n  min-width: 1060px;\n  height: 56px;\n  display: flex;\n  gap: 32px;\n  align-items: center;\n}\n\n.toolbarRight {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-grow: 1;\n  gap: 24px;\n  overflow: auto;\n}\n\n.title_container {\n  width: 360px;\n  flex-grow: 0;\n  flex-shrink: 0;\n}\n\n.title_title {\n  font-size: 17px;\n}\n\n.title_icon {\n  --size: 20px;\n}\n\n.tab_container, .tab_container:first-of-type {\n  cursor: pointer;\n  padding: 0px;\n}\n\n.tab_container:first-of-type {\n  margin-left: 4px;\n}\n\n.tab_container:not(:last-of-type) {\n  margin-right: 48px;\n}\n\n.tab_container:hover {\n  background-color: unset;\n}\n\n.tab_title {\n  font-size: 15px;\n  color: rgba(0, 0, 0, 0.9);\n}\n\n.tab_indicator {\n  border-radius: 2px;\n  margin: 8px 2px 0px;\n}\n\n.tableHeader_container {\n  height: 48px;\n}\n\n.tableHeader_cellContent {\n  font-size: 14px;\n  color: rgba(0, 0, 0, 0.8);\n}\n\n.content {\n  min-width: 1060px;\n  display: flex;\n  gap: 32px;\n  margin-top: 0px;\n}\n\n.outlineCard {\n  height: auto;\n  flex-grow: 1;\n  overflow: auto;\n}\n\n.customerCard_container {\n  width: 360px;\n  flex-shrink: 0;\n}\n\n.salesReport_item:first-child {\n  margin-left: 0px;\n}\n\n.options {\n  display: flex;\n  align-items: center;\n}\n\n.option {\n  --size: 24px;\n  margin-left: 28px;\n}\n\n.confirmModal_content {\n  font-size: 15px;\n  line-height: 1.6;\n}\n\n.confirmModal_content b {\n  font-weight: 500;\n}\n\n.error {\n  margin-top: 12px;\n  padding: 8px 12px;\n  border-radius: var(--radius-lg);\n  background-color: var(--color-red-50);\n  color: var(--accent-color);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `business-container-Jkmj2`,
	"toolbar": `business-toolbar-lEADJ`,
	"toolbarRight": `business-toolbarRight-Eo0aA`,
	"title_container": `business-title_container-YINeu`,
	"title_title": `business-title_title-ahSgm`,
	"title_icon": `business-title_icon-wAVXj`,
	"tab_container": `business-tab_container-xcWPa`,
	"tab_title": `business-tab_title-okVb5`,
	"tab_indicator": `business-tab_indicator-gyHBB`,
	"tableHeader_container": `business-tableHeader_container-oktDX`,
	"tableHeader_cellContent": `business-tableHeader_cellContent-pzr6m`,
	"content": `business-content-ih5Le`,
	"outlineCard": `business-outlineCard-poAbG`,
	"customerCard_container": `business-customerCard_container-Ap1yT`,
	"salesReport_item": `business-salesReport_item-nCTM_`,
	"options": `business-options-No5IO`,
	"option": `business-option-Qn7e5`,
	"confirmModal_content": `business-confirmModal_content-_haz5`,
	"error": `business-error-OQghz`
};
export default ___CSS_LOADER_EXPORT___;
